document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const openDrawer = document.querySelector('[data-drawer-open]');
  const closeDrawer = document.querySelectorAll('[data-drawer-close]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchToggle = document.querySelector('[data-search-toggle]');

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  };
  openDrawer?.addEventListener('click', () => setDrawer(true));
  closeDrawer.forEach(el => el.addEventListener('click', () => setDrawer(false)));

  searchToggle?.addEventListener('click', () => {
    const open = !searchPanel?.classList.contains('is-open');
    searchPanel?.classList.toggle('is-open', open);
    searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) searchPanel?.querySelector('input')?.focus();
  });

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const json = root.querySelector('[data-product-variants]');
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch(e) { return; }
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-product-compare]');
    const submit = root.querySelector('[data-product-submit]');
    const status = root.querySelector('[data-product-status]');
    const currency = root.dataset.currency || '$';
    const formatMoney = cents => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: root.dataset.currencyCode || 'USD'}).format(cents/100); }
      catch(e) { return currency + (cents/100).toFixed(2); }
    };
    const updateVariant = () => {
      const selected = [...root.querySelectorAll('[data-option-position]:checked')]
        .sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition))
        .map(i=>i.value);
      const variant = variants.find(v => v.options.every((o,i) => o === selected[i]));
      if (!variant) {
        submit.disabled = true;
        submit.textContent = 'Unavailable';
        if (status) status.textContent = 'This combination is unavailable.';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else compareEl.hidden = true;
      }
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (status) status.textContent = variant.available ? 'In stock — ready to add to cart.' : 'This size is currently sold out.';
      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };
    root.querySelectorAll('[data-option-position]').forEach(input => input.addEventListener('change', updateVariant));
    updateVariant();
  });

  document.querySelectorAll('[data-sort-select]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
});
